/**
 * Catalogue SEO : route → { title, description }.
 * Pattern admin : « Page » | Happy Paws
 */

const SITE = 'Happy Paws';
const DEFAULT_DESCRIPTION =
  'Pet-sitting à domicile à Colombiers et dans un rayon de 25 km. ACACED, RC Pro, bilingue FR/EN. Contact gratuit, rencontre à domicile, photos à chaque visite.';

/** @type {Record<string, { title: string, description: string }>} */
export const PAGE_META = {
  '/': {
    title: `${SITE} — Pet-sitting à domicile à Colombiers (17460)`,
    description: DEFAULT_DESCRIPTION,
  },
  '/services': {
    title: `Forfaits pet-sitting à domicile | ${SITE}`,
    description: 'Balades, visites à domicile et forfait confort pour chiens, chats et NACs à Colombiers et dans un rayon de 25 km. Tarifs indicatifs, devis après rencontre à domicile.',
  },
  '/devis': {
    title: `Demander un devis | ${SITE}`,
    description: 'Obtenez un devis de pet-sitting à domicile à Colombiers (rayon 25 km). Gratuit, sans engagement. Réponse sous 24 h ouvrées en général.',
  },
  '/demande-de-reservation': {
    title: `Réserver une visite | ${SITE}`,
    description: 'Demandez un créneau de pet-sitting à domicile à Colombiers (rayon 25 km). Créneaux issus de l’agenda, confirmation personnelle, parcours transparent.',
  },
  '/contact': {
    title: `Contact | ${SITE} — Pet-sitting Colombiers`,
    description: 'Contactez Happy Paws pour un pet-sitting à domicile à Colombiers (rayon 25 km). Réponse sous 24 h ouvrées en général. FR / EN.',
  },
  '/a-propos': {
    title: `À propos | ${SITE} — Pet-sitting à Colombiers`,
    description: 'Happy Paws : pet-sitting à domicile à Colombiers (17460), rayon 25 km. Bien-être animal, transparence, rencontre à domicile, ACACED et RC Pro.',
  },
  '/mentions-legales': {
    title: `Mentions légales | ${SITE}`,
    description: 'Mentions légales du site Happy Paws.',
  },
  '/politique-de-confidentialite': {
    title: `Politique de confidentialité | ${SITE}`,
    description: 'Politique de confidentialité et protection des données personnelles — Happy Paws.',
  },
  '/login': {
    title: `Connexion | ${SITE}`,
    description: 'Espace administrateur Happy Paws.',
  },
  '/forgot-password': {
    title: `Mot de passe oublié | ${SITE}`,
    description: 'Réinitialisation du mot de passe — Happy Paws.',
  },
  '/reset-password': {
    title: `Nouveau mot de passe | ${SITE}`,
    description: 'Définir un nouveau mot de passe — Happy Paws.',
  },
  '/dashboard': {
    title: `Tableau de bord | ${SITE}`,
    description: 'Pilotage de l’activité Happy Paws.',
  },
  '/bookings': {
    title: `Réservations | ${SITE}`,
    description: 'Gestion des réservations et disponibilités.',
  },
  '/bookings/resources': {
    title: `Ressources de planning | ${SITE}`,
    description: 'Gestion des ressources de planning.',
  },
  '/contacts': {
    title: `Contacts | ${SITE}`,
    description: 'Carnet de contacts et fiches clients.',
  },
  '/quotes': {
    title: `Devis clients | ${SITE}`,
    description: 'Suivi des devis clients.',
  },
  '/quotes/requests': {
    title: `Demandes de devis | ${SITE}`,
    description: 'Demandes de devis entrantes.',
  },
  '/catalog': {
    title: `Services catalogue | ${SITE}`,
    description: 'Catalogue des prestations.',
  },
  '/crm': {
    title: `Pipeline CRM | ${SITE}`,
    description: 'Pipeline commercial.',
  },
  '/crm/deals': {
    title: `Opportunités | ${SITE}`,
    description: 'Opportunités commerciales.',
  },
  '/support': {
    title: `Support | ${SITE}`,
    description: 'Tickets support.',
  },
  '/notifications': {
    title: `Modèles d’e-mails | ${SITE}`,
    description: 'Modèles de notifications e-mail.',
  },
  '/api-keys': {
    title: `Clés API | ${SITE}`,
    description: 'Gestion des clés API.',
  },
  '/automation': {
    title: `Automatisations | ${SITE}`,
    description: 'Règles d’automatisation.',
  },
  '/workflows': {
    title: `Workflows | ${SITE}`,
    description: 'Workflows métier.',
  },
  '/workflow-definitions': {
    title: `Modèles de workflow | ${SITE}`,
    description: 'Définitions de workflows.',
  },
  '/content': {
    title: `Contenus | ${SITE}`,
    description: 'Gestion des contenus.',
  },
  '/media': {
    title: `Médiathèque | ${SITE}`,
    description: 'Bibliothèque média.',
  },
  '/admin/users': {
    title: `Utilisateurs | ${SITE}`,
    description: 'Gestion des utilisateurs.',
  },
  '/admin/permissions': {
    title: `Permissions | ${SITE}`,
    description: 'Rôles et permissions.',
  },
  '/profile': {
    title: `Profil | ${SITE}`,
    description: 'Profil utilisateur.',
  },
};

export const DEFAULT_PAGE_META = {
  title: SITE,
  description: DEFAULT_DESCRIPTION,
};

/**
 * Résout les meta pour un pathname (ignore query/hash ; fallback préfixe pour routes dynamiques).
 * @param {string} pathname
 */
export function resolvePageMeta(pathname) {
  const path = (pathname || '/').split('?')[0].replace(/\/$/, '') || '/';
  if (PAGE_META[path]) return PAGE_META[path];

  const prefixes = Object.keys(PAGE_META)
    .filter((k) => k !== '/' && path.startsWith(`${k}/`))
    .sort((a, b) => b.length - a.length);
  if (prefixes[0]) return PAGE_META[prefixes[0]];

  return DEFAULT_PAGE_META;
}
